module.exports = __webpack_public_path__ + "img/hcml_main0.fadc9d52.jpg";